import { Flex, Link, useBreakpointValue, Button, Box } from '@chakra-ui/react';
import NextLink from 'next/link';
import { FC, Fragment, useState } from 'react';

import { ThinProfile } from '@/resources/ThinProfile';

interface IAuthorsListProps {
  sortedProfiles: Array<ThinProfile>;
}

export const AuthorsList: FC<IAuthorsListProps> = ({ sortedProfiles }) => {
  const [expanded, setExpanded] = useState<boolean>(false);
  const maxToShow = useBreakpointValue({ base: 10, md: 16, lg: 18 });

  const showShowMoreButton = sortedProfiles?.length > maxToShow;

  const arrayToShow = expanded ? sortedProfiles : sortedProfiles?.slice(0, maxToShow);

  return (
    <Box mt={2}>
      <Flex flexWrap="wrap">
        <AuthorLinks lectureProfiles={arrayToShow} />
      </Flex>
      {showShowMoreButton && (
        <Button height={12} variant="unstyled" onClick={() => setExpanded((e) => !e)}>
          show {expanded ? 'less' : 'more'} authors
        </Button>
      )}
    </Box>
  );
};

const AuthorLinks: FC<{ lectureProfiles: Array<ThinProfile> }> = ({ lectureProfiles }) => {
  return (
    <Fragment>
      {lectureProfiles?.map((lectureProfile, index) => (
        <Fragment key={lectureProfile.id}>
          <NextLink href={`/speakers/${lectureProfile.linkSlug}`} passHref>
            <Link>{lectureProfile.fullName}</Link>
          </NextLink>
          {index < lectureProfiles.length - 1 && <span>,&nbsp;</span>}
        </Fragment>
      ))}
    </Fragment>
  );
};
